<template>
    <div class="preview_wrap">
        <el-tabs v-model="tabCurrent" @tab-click="handleTabClick">
            <el-tab-pane label="已投放" name="release">
                <Release v-if="tabCurrent === 'release'" @callback="handleCallback"></Release>
            </el-tab-pane>
            <el-tab-pane label="已屏蔽" name="blocked">
                <Blocked v-if="tabCurrent === 'blocked'" @callback="handleCallback"></Blocked>
            </el-tab-pane>
            <el-tab-pane label="已通过" name="passed">
                <Passed v-if="tabCurrent === 'passed'" @callback="handleCallback"></Passed>
            </el-tab-pane>
        </el-tabs>
        
        <!-- scroll top -->
        <div class="btn_scroll_top" v-if="scrollTopVisible" @click="handleScrollTop">
            <svg t="1713440979235" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4251" width="40" height="40">
                <path d="M792.748 599.403l-257.312-259.001c-5.7-5.73-13.683-8.998-23.437-8.998s-16.541 3.881-21.63 8.971l-261.758 260.585c-11.205 11.174-11.231 29.313-0.031 40.513 13.731 13.731 34.927 5.614 40.544 0.056l214.226-213.168v372.648c0 15.844 12.835 28.653 28.649 28.653 15.817 0 28.653-12.813 28.653-28.653v-374.053l211.469 212.845c5.587 5.617 12.981 8.453 20.311 8.453 7.337 0 14.615-2.784 20.202-8.338 11.257-11.148 11.288-29.313 0.113-40.514v0 0zM827.161 251.635h-630.316c-15.817 0-28.653-12.835-28.653-28.645 0-15.818 12.835-28.653 28.653-28.653h630.316c15.84 0 28.645 12.835 28.645 28.653 0 15.81-12.805 28.645-28.645 28.645v0 0zM827.161 251.635z" fill="#409EFF" p-id="4252"></path>
            </svg>
        </div>
    </div>
</template>

<script>
import Release from './Release';
import Blocked from './Blocked';
import Passed from './Passed';

export default {
    name: 'review',
    
    data () {
        return {
            mainBox: '',
            tabCurrent: 'release',
            tabCom: '',
            scrollTopVisible: false
        }
    },
    
    components: {
        Release,
        Blocked,
        Passed
    },
    
    methods: {
        init() {
            this.mainBox = document.querySelector('.main-box');
            
            this.mainBox.addEventListener('scroll', (e) => {
                let _scrollTop = e.target.scrollTop || e.srcElement.scrollTop;
                this.scrollTopVisible = _scrollTop > 0;
            });
        },
        
        handleTabClick(tab, event) {
            console.log(tab, event);
            this.$nextTick(() => {
                this.handleScrollTop();
            });
        },
        
        handleCallback(data) {
            if (data && data.scrollTop) {
                this.handleScrollTop();
            }
        },
        
        handleScrollTop() {
            this.mainBox.scrollTop = 0;
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss">
.layout-box .content-box .main-box{
    overflow-x: hidden;
    overflow-y: auto;
}
.preview_wrap{
    position: relative;
    padding: 0 30px 10px 30px;
    & .el-tabs__header{
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fff;
    }
    & .el-tabs__content{
        overflow: visible;
    }
    & .btn_scroll_top{
        position: fixed;
        right: 50px;
        bottom: 100px;
        width: 40px;
        height: 40px;
        cursor: pointer;
    }
}
</style>
